/* eslint-disable react/no-unknown-property */
import React from "react"

import { useField } from "formik"
import Styles from "./inputSelect.module.scss"

const InputSelect = ({ label, list, ...props }) => {
  const [field, meta, helpers] = useField(props)

  const handleChange = e => field.onChange(e)

  return (
    <div className={Styles.wrapper}>
      <label htmlFor={field.name} className={Styles.label}>
        {label}
      </label>
      <select
        id={field.name}
        as="select"
        name={field.name}
        className={Styles.input}
        value={field.value}
        onChange={handleChange}
      >
        {list.map(({ label: name, value }) => (
          <option value={value}>{name}</option>
        ))}
      </select>
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </div>
  )
}

export default InputSelect
